import { strIsNullOrEmpty } from "@fox/atoms";
import { Link } from "./contracts";

export const redirect = (link: Link) => {
	if (!strIsNullOrEmpty(link?.url)) {
		if (link.target == "_blank") {
			window.open(link.url, link.target);
		} else {
			window.location.href = link.url;
		}
	}
};
